<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <div class="ibox">
      <div class="tabs-container">
        <ul class="nav nav-tabs" role="tablist">
          <li class="active"><a class="nav-link" data-toggle="tab"  href="#backorders" @click="activeComponent = 'backordersTab'">Dynadot Backorders</a></li>
          <li><a class="nav-link" data-toggle="tab"  href="#orders" @click="activeComponent = 'ordersTab'">Orders</a></li>
          <li><a class="nav-link" data-toggle="tab"  href="#domains" @click="activeComponent = 'domainsTab'">Domains</a></li>
        </ul>
        <div class="tab-content">
        </div>
        <div class="tab-pane ibox-content active" role="tabpanel" id="feed">
          <div class="row">
            <component :is="activeComponent"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import DomainsTab from './Domains/DomainsTab'
import OrdersTab from './Domains/OrdersTab'
import BackordersTab from './Domains/BackordersTab'

export default {
  data () {
    return {
      activeComponent: 'backordersTab',
      domains: []
    }
  },
  components: {
    domainsTab: DomainsTab,
    ordersTab: OrdersTab,
    backordersTab: BackordersTab
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Domains.vue